import styled from 'styled-components';

export default styled.div`
  padding: 10px 0;
  margin-top: 10px;
  border-top: 1px solid #5a6477;
`;
